import { push, goBack, goForward } from 'connected-react-router';

export const navigateTo = (path) => (dispatch) => {
  dispatch(push(path));
};

export const navigateForward = () => (dispatch) => {
  dispatch(goForward());
};

export const navigateBack = () => (dispatch) => {
  dispatch(goBack());
};
